var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4286 0H40.1429C39.2754 0 38.5714 0.702429 38.5714 1.57143V7.85714C38.5714 8.72614 39.2754 9.42857 40.1429 9.42857H41.7143V14.1429H33.8571C33.8069 14.1429 33.7644 14.1664 33.7157 14.1711C31.7279 12.2131 29.0046 11 26 11C22.2396 11 18.916 12.8999 16.9313 15.7866C16.8134 15.7583 16.6987 15.7143 16.5714 15.7143H10.2857V9.42857H11.8571C12.7246 9.42857 13.4286 8.72614 13.4286 7.85714V1.57143C13.4286 0.702429 12.7246 0 11.8571 0H5.57143C4.704 0 4 0.702429 4 1.57143V7.85714C4 8.72614 4.704 9.42857 5.57143 9.42857H7.14286V17.2857C7.14286 18.1547 7.84686 18.8571 8.71429 18.8571H15.4636C15.165 19.8534 15 20.9079 15 22C15 28.0641 19.9343 33 26 33C27.0921 33 28.1466 32.835 29.1429 32.5364V37.7143H13.4286V36.1429C13.4286 35.2739 12.7246 34.5714 11.8571 34.5714H5.57143C4.704 34.5714 4 35.2739 4 36.1429V42.4286C4 43.2976 4.704 44 5.57143 44H11.8571C12.7246 44 13.4286 43.2976 13.4286 42.4286V40.8571H30.7143C31.5817 40.8571 32.2857 40.1547 32.2857 39.2857V31.4286C32.2857 31.3013 32.2417 31.1866 32.2134 31.0687C35.1001 29.084 37 25.7604 37 22C37 20.3123 36.6056 18.7173 35.9236 17.2857H43.2857C44.1531 17.2857 44.8571 16.5833 44.8571 15.7143V9.42857H46.4286C47.296 9.42857 48 8.72614 48 7.85714V1.57143C48 0.702429 47.296 0 46.4286 0ZM7.14286 3.14286H10.2857V6.28571H7.14286V3.14286ZM10.2857 40.8571H7.14286V37.7143H10.2857V40.8571ZM33.6984 20.4286H27.5714V14.3016C30.6451 14.9286 33.0714 17.3549 33.6984 20.4286ZM18.1429 22C18.1429 18.2066 20.8473 15.0323 24.4286 14.3016V21.5647L20.7074 27.7671C19.1423 26.3309 18.1429 24.2864 18.1429 22ZM23.404 29.381L26.8894 23.5714H33.6984C32.9677 27.1527 29.795 29.8571 26 29.8571C25.0854 29.8571 24.2211 29.6701 23.404 29.381ZM44.8571 6.28571H41.7143V3.14286H44.8571V6.28571Z",
    fill: "#5DEE7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_140",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_140",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramGreen);
export default __webpack_public_path__ + "static/media/diagram-green.96e50efa1c289ea41ed9443707671a6f.svg";
export { ForwardRef as ReactComponent };